import * as Constants from '../constants';

import React, { useState, useEffect } from 'react';

import Loading from '../components/UI/Loading';
import ScrollContainer from '../components/UI/ScrollContainer';
import UserProfileForm from '../components/profile/UserProfileForm';
import MessageDialog from '../components/UI/MessageDialog';
import AdvertisementPanel from '../components/UI/AdvertisementPanel';

import bcrypt from 'bcryptjs';

function RegisterPage() {
    const [isLoading, setIsLoading] = useState(true);
    const [responseMsg, setResponseMsg] = useState("");
    const [createConfirmationIsShown, setCreateConfirmationIsShown] = useState(false);
    const [msgVariant, setMsgVariant] = useState("warning");
    const [responseHeader, setResponseHeader] = useState("");

    const createProfile = async (data) => {
        data['password'] = bcrypt.hashSync(data['password'], 12);
        data['confirmPassword'] = bcrypt.hashSync(data['password'], 12);
        const url = Constants.PROFILE_CREATE;

        await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); // Converte a resposta em JSON
            })
            .then(data => {
                if (data.status === 200) {
                    setMsgVariant("success");
                    setResponseHeader("Sucesso!");
                } else {
                    setMsgVariant("warning");
                    setResponseHeader("Atenção!");
                }
                setResponseMsg(data.message);
                setCreateConfirmationIsShown(true);
            })
            .catch(error => {
                console.error('Erro na requisição:', error);
            });
    };

    const closeMessageDialogHandler = () => {
        setCreateConfirmationIsShown(false);
    };

    const getLastBusinessDay = () => {
        // Obtém a data atual no fuso horário de Brasília
        const now = new Date();
        const options = { timeZone: 'America/Sao_Paulo' };
        const currentDate = new Date(now.toLocaleString('en-US', options));

        // Obtém o dia da semana (0 = domingo, 6 = sábado)
        const dayOfWeek = currentDate.getDay();

        // Ajusta a data se for sábado ou domingo
        if (dayOfWeek === 0) {
            // Domingo: Subtrai 2 dias para obter a sexta-feira anterior
            currentDate.setDate(currentDate.getDate() - 2);
        } else if (dayOfWeek === 6) {
            // Sábado: Subtrai 1 dia para obter a sexta-feira anterior
            currentDate.setDate(currentDate.getDate() - 1);
        }

        // Retorna a data formatada como YYYY-MM-DD
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Mês é 0-based
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${month}-${day}-${year}`;
    }

    // const dolarQuoteHandler = async () => {
    //     let day = getLastBusinessDay();
    //     const url = "https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/odata/CotacaoDolarDia(dataCotacao=@dataCotacao)?@dataCotacao=%27"+ day +"%27&$top=100&$format=json";
    //     await fetch(url)
    //         .then(response => {
    //             if (!response.ok) {
    //                 throw new Error(`HTTP error! status: ${response.status}`);
    //             }
    //             return response.json(); // Converte a resposta em JSON  
    //         })
    //         .then(data => {
    //             const compra = Number(data.value[0].cotacaoCompra);
    //             console.warn(compra);
    //             const venda = Number(data.value[0].cotacaoVenda);
    //             localStorage.setItem("dollar",compra);
    //         })
    //         .catch(error => {
    //             console.error('Erro na requisição:', error);
    //         });        
    // };

    useEffect(() => {
        setIsLoading(true);
        localStorage.clear();
        // dolarQuoteHandler();
        setIsLoading(false);
    }, []);

    return <>
        {isLoading && <Loading />}
        {createConfirmationIsShown && <MessageDialog
            variant={msgVariant}
            onClose={closeMessageDialogHandler}
            header={responseHeader}
            message={responseMsg}
        />}
        {!isLoading && <>
            <div className="row mainPanel px-2">
                <div className="col col-md-12">
                    <ScrollContainer heightMultiplier={0.7337}>
                        <UserProfileForm create={true} submitHandler={createProfile} editPassword={false} />
                    </ScrollContainer>
                </div>
            </div>

            <div className="row adPanel px-2">
                <div className="col col-md-12">
                    <AdvertisementPanel
                        title="Conheça nossas soluções"
                        description="Tecnologia e inovação para transformar seus negócios."
                        image="https://terradata.com.br/img/logo.png"
                        link="https://www.terradata.com.br"
                        height={100}
                    />
                </div>
            </div>
        </>}
    </>

}

export default RegisterPage;